import React, { useEffect, useState } from "react";
import "./Addsupport.css";

/* =========================
   BASE URL & API
========================= */
const BASE_URL =
  "https://backend-ourcountryourpeople-4.onrender.com";

const API = `${BASE_URL}/api/support`;

export default function AddSupport() {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [preview, setPreview] = useState(null);

  const [supports, setSupports] = useState([]);
  const [editId, setEditId] = useState(null);

  const [status, setStatus] = useState("");
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  /* =========================
     FETCH SUPPORT LIST
  ========================= */
  const fetchSupports = async () => {
    try {
      const res = await fetch(API);
      const data = await res.json();
      setSupports(data);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchSupports();
  }, []);

  /* =========================
     IMAGE RESIZE & COMPRESS
  ========================= */
  const resizeImage = (file) =>
    new Promise((resolve) => {
      const img = new Image();
      const canvas = document.createElement("canvas");
      const reader = new FileReader();

      reader.onload = (e) => (img.src = e.target.result);
      reader.readAsDataURL(file);

      img.onload = () => {
        const MAX_WIDTH = 900;
        let { width, height } = img;

        if (width > MAX_WIDTH) {
          const scale = MAX_WIDTH / width;
          width = MAX_WIDTH;
          height = height * scale;
        }

        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => resolve(blob),
          "image/jpeg",
          0.7
        );
      };
    });

  /* =========================
     FILE CHANGE
  ========================= */
  const handleFileChange = async (e) => {
    const selected = e.target.files[0];
    if (!selected || !selected.type.startsWith("image/")) return;

    const blob = await resizeImage(selected);

    const fixedFile = new File([blob], "support.jpg", {
      type: "image/jpeg",
    });

    setFile(fixedFile);
    setPreview(URL.createObjectURL(fixedFile));
  };

  /* =========================
     ADD / UPDATE SUBMIT
  ========================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (editId && !file && !title && !subtitle) {
  setStatus("Nothing to update ❌");
  return;
}


    const formData = new FormData();
    if (file) formData.append("photo", file);
    formData.append("title", title);
    formData.append("subtitle", subtitle);

    setUploading(true);
    setStatus("");

    const xhr = new XMLHttpRequest();
    xhr.open(
      editId ? "PUT" : "POST",
      editId ? `${API}/${editId}` : API
    );

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) {
        setProgress(Math.round((e.loaded * 100) / e.total));
      }
    };

    xhr.onload = () => {
      setUploading(false);
      setProgress(0);

      if (xhr.status === 200 || xhr.status === 201) {
        setStatus(
          editId
            ? "Updated successfully ✅"
            : "Uploaded successfully ✅"
        );
        resetForm();
        fetchSupports();
      } else {
        setStatus("Operation failed ❌");
      }
    };

    xhr.onerror = () => {
      setUploading(false);
      setStatus("Server error ❌");
    };

    xhr.send(formData);
  };

  /* =========================
     EDIT HANDLER
  ========================= */
  const handleEdit = (item) => {
    setEditId(item._id);
    setTitle(item.title);
    setSubtitle(item.subtitle || "");

    // ✅ Correct image preview URL
    setPreview(`${BASE_URL}/api/support/${item._id}/image`);

    setFile(null);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setEditId(null);
    setTitle("");
    setSubtitle("");
    setFile(null);
    setPreview(null);
  };

  /* =========================
     RENDER
  ========================= */
  return (
    <div className="add-support-container">
      <h2>{editId ? "Edit Support" : "Add Support Photo"}</h2>

      {/* ===== FORM ===== */}
      <form onSubmit={handleSubmit} className="add-support-form">
        <input
          type="text"
          placeholder="Enter name"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <input
          type="text"
          placeholder="Enter subtitle"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
        />

        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
        />

        {preview && (
          <img
            src={preview}
            alt="preview"
            className="preview"
          />
        )}

        <button type="submit" disabled={uploading}>
          {uploading
            ? "Uploading..."
            : editId
            ? "Update"
            : "Upload"}
        </button>

        {editId && (
          <button type="button" onClick={resetForm}>
            Cancel
          </button>
        )}

        {uploading && <p>Uploading... {progress}%</p>}
      </form>

      {status && <p className="status">{status}</p>}

      {/* ===== LIST ===== */}
      <h3>Support List</h3>

      <div className="support-grid">
        {supports.map((item) => (
          <div key={item._id} className="support-card">
            <img
              src={`${BASE_URL}/api/support/${item._id}/image`}
              alt={item.title}
            />
            <h4>{item.title}</h4>
            <p>{item.subtitle}</p>

            <button onClick={() => handleEdit(item)}>
              Edit ✏️
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
